import React, { useState, useEffect } from "react";
import classnames from "classnames";
import * as locale from "locale-codes";
import g from "../utils/globals";
import Svg from "./Svg";
import captionsIcon from "../../img/captions.svg";
import closeIcon from "../../img/close.svg";

const CaptionsSwitcher = props => {
  const { actions, player, controlsAnimation } = props;
  const [openedList, setOpenedList] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [sortedTextTracks, setSortedTextTracks] = useState(null);

  const openCaptionsListHandler = () => {
    setOpenedList(!openedList);
  };

  const onDisableCaptions = () => {
    if (!disabled) {
      setDisabled(true);
      Object.keys(player.textTracks).map(idx => {
        player.textTracks[idx].mode = "disabled";
      });
    }
  };

  useEffect(() => {
    if (player?.textTracks?.length) {
      const textTracksSorted = Object.keys(player.textTracks).reduce((langs, index) => {
        const caption = player.textTracks[index];
        if (caption?.label?.length) {
          const isActive = g.languageCode === caption.label;
          const language = locale.getByTag(caption.label.replace("_", "-")) || locale.getByTag(caption.label.replace("_", "-Latn-"));
          const label = language?.local || language?.name || caption.label;
          const tag = language?.tag || caption.label;
          const ocurrences = language && Object.values(langs).filter(lang => lang.name === language.name);
          const value = {
            ...language,
            active: isActive,
            captionTag: caption.label,
            index,
            label,
            tag,
          };
          if (isActive) {
            player.textTracks[index].mode = "showing";
            setDisabled(false);
          }
          if (ocurrences?.length) {
            if (ocurrences.length === 1) {
              const occurrence = ocurrences[0];
              const occurrenceCountry = occurrence.captionTag.split("_")[1];
              if (occurrenceCountry) {
                langs[occurrence.tag].locatedText = `${occurrence.label} (${occurrenceCountry})`;
              }
            }
            const country = value.captionTag.split("_")[1];
            if (country) {
              value.locatedText = `${value.label} (${country})`;
            }
          }
          langs[tag] = value;
        }
        return langs;
      }, {});
      if (Object.keys(textTracksSorted).length) {
        setSortedTextTracks(Object.values(textTracksSorted));
      }
    }
  }, [player.textTracks?.length]);

  if (sortedTextTracks?.length) {
    return (
      <div
        className={classnames("video-captions-switcher", {
          openedList,
        })}
      >
        <div className="video-captions-switcher-icon-wrapper" onClick={openCaptionsListHandler}>
          <Svg svg={captionsIcon} />
        </div>
        <div className="video-captions-switcher-list-wrapper">
          <div className="close-icon-wrapper" onClick={openCaptionsListHandler}>
            <Svg svg={closeIcon} />
          </div>
          <div
            className="video-captions-switcher-list"
            onMouseMove={() => {
              controlsAnimation();
            }}
          >
            <div
              className={classnames("caption-option", {
                "disabled-caption": disabled,
              })}
              onClick={onDisableCaptions}
            >
              Off
            </div>
            {sortedTextTracks.map((caption, idx) => {
              return (
                <div
                  key={idx}
                  className={classnames("caption-option", {
                    "active-captions": player.textTracks[caption.index].mode === "showing",
                  })}
                  onClick={() => {
                    if (disabled) {
                      setDisabled(false);
                    }
                    Object.keys(player.textTracks).map(idx => {
                      if (idx === caption.index) {
                        player.textTracks[idx].mode = "showing";
                        actions.activateTextTrack(player.textTracks[idx]);
                      } else {
                        player.textTracks[idx].mode = "hidden";
                      }
                    });
                  }}
                >
                  {caption.locatedText || caption.label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default CaptionsSwitcher;
